import { cn } from "@/lib/cn";
import { getFrameTypeIcon } from "./concept-icons";
import { openFrameInProject } from "@/components/layout/cross-project-navigation";

export interface FrameLinkProps {
  frameId: string;
  /** The frame's project: the chip opens it there from any window. */
  projectId: string;
  title: string;
  frameType?: string;
  className?: string;
}

export function FrameLink({
  frameId,
  projectId,
  title,
  frameType,
  className,
}: FrameLinkProps) {
  const Icon = getFrameTypeIcon(frameType);

  const handleClick = () => {
    void openFrameInProject(
      { id: frameId, projectId, projectName: null },
      { waitForLoad: true },
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "inline-flex items-center gap-appkit-2xs rounded-control-sm border px-appkit-2xs py-appkit-2xs text-appkit-mini font-medium text-accent transition-colors",
        className,
      )}
      data-testid={`frame-link-${frameId}`}
    >
      <Icon className="h-2.5 w-2.5" />
      <span className="max-w-[120px] truncate">{title}</span>
    </button>
  );
}
